import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faPhone, faTag, faUsers, faUser } from '@fortawesome/free-solid-svg-icons';
import { SaleOrder } from 'service';

export const OrderHeader = ({ order, user }: { order: SaleOrder, user: any }) => {
    return (
        <>
            {order?.id > 0 && (
                <div className="card-body p-0 pt-2">
                    <table className="table table-sm mb-0">
                        <tbody>
                            {((user.roleId <= 3) || (user.productionPlantId != 13 && user.productionPlantId != 14 && user.productionPlantId != 16)) && (
                                <tr>
                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                        <FontAwesomeIcon icon={faUser} />
                                    </td>
                                    <td colSpan={2}>
                                        Party:
                                        <div className="fw-bold">{order.party.name}</div>
                                    </td>
                                </tr>
                            )}
                            {/*(user && user.roleId <= 4) && order?.party?.mobileNumber && (
                                <tr>
                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                        <FontAwesomeIcon icon={faPhone} />
                                    </td>
                                    <td colSpan={2}>
                                        Contact:
                                        <div className="fw-bold">{order.party.mobileNumber}
                                            <a
                                                className="btn btn-primary btn-sm float-end"
                                                href={"tel:" + order.party.mobileNumber}
                                                style={{ textDecoration: "none", color: "#fff" }}
                                            >
                                                <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                Call
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            )*/}
                            <tr className="align-middle">
                                <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                    <FontAwesomeIcon icon={faCalendar} />
                                </td>
                                <td colSpan={2}>
                                    Date:
                                    <div className="fw-bold">{moment(order.date).format("DD MMM YYYY")}</div>
                                </td>
                            </tr>
                            {user && user.productionPlantId == 0 && (
                                <tr className="align-middle">
                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                        <FontAwesomeIcon icon={faUsers} />
                                    </td>
                                    <td colSpan={2}>
                                        Assigned To:
                                        <div className="fw-bold">{order.productionPlantName}</div>
                                    </td>
                                </tr>
                            )}
                            {order.extraInformation && order.extraInformation.length > 0 && (
                                <tr className="align-middle">
                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                        <FontAwesomeIcon icon={faTag} />
                                    </td>
                                    <td colSpan={2}>
                                        Brand:
                                        <div className="fw-bold">{order.extraInformation}</div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {(order.status == 1) && (
                        <div className="alert alert-danger p-0 text-center" style={{ margin: 10 }}>
                            Order is yet to be confirmed.
                        </div>
                    )}
                </div>
            )}
        </>
    );
};